/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_How_Yes_Card_DetailInputs */

const en_landing_how_yes_card_detail = /** @type {(inputs: Landing_How_Yes_Card_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuesday, 18:00`)
};

const pl_landing_how_yes_card_detail = /** @type {(inputs: Landing_How_Yes_Card_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wtorek, 18:00`)
};

/**
* | output |
* | --- |
* | "Tuesday, 18:00" |
*
* @param {Landing_How_Yes_Card_DetailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_how_yes_card_detail = /** @type {((inputs?: Landing_How_Yes_Card_DetailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_How_Yes_Card_DetailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_how_yes_card_detail(inputs)
	return en_landing_how_yes_card_detail(inputs)
});